/* Push Offre — copie du code promo au clic (délégué, une seule fois). */
(function () {
  if (window.__pushOfferCopyBound) return;
  window.__pushOfferCopyBound = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-copy-code]');
    if (!trigger) return;

    var code = trigger.getAttribute('data-copy-code');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).catch(function () {});
    }
    trigger.setAttribute('data-copied', '');
    var label = trigger.querySelector('[data-copy-label]');
    if (label) label.textContent = 'Copié ✓';
  });
})();
